export function setUser(payload){
    return{
        type:'setUser',
        payload
    }
}